var React = require('react');

function Alert (props) {
    return React.createElement("svg",props,[React.createElement("desc",{"key":0},"Created with Sketch."),React.createElement("defs",{"key":1}),React.createElement("g",{"id":"alert","key":2},React.createElement("path",{"d":"M12,12 L10,12 L10,8 L12,8 L12,12 Z M12,16 L10,16 L10,14 L12,14 L12,16 Z M0,19 L22,19 L11,0 L0,19 Z","id":"Shape"}))]);
}

Alert.defaultProps = {"width":"22px","height":"19px","viewBox":"0 0 22 19","version":"1.1"};

module.exports = Alert;

Alert.default = Alert;
